{
  "cancellation": {
    "confirmationTitle": "Cancelar assinatura",
    "confirmationBodyOne": "Tem certeza de que deseja cancelar sua assinatura?",
    "confirmationBodyTwo": "Você não terá mais acesso à sua conta e aos dados após a expiração da assinatura",
    "reasonHeadingOne": "Lamentamos ver você sair.",
    "reasonHeadingTwo": "Adoraríamos receber sua opinião sobre como melhorar a Iventis.",
    "reasonSubheadingOne": "Qual é o principal motivo do cancelamento?",
    "reasonSubheadingTwo": "Forneça qualquer feedback adicional",
    "reasonOne": "Não estou fazendo uso completo do Iventis",
    "reasonTwo": "Estou achando difícil de usar",
    "reasonThree": "Não tem um recurso que eu estou procurando",
    "reasonFour": "É muito caro",
    "reasonFive": "Decidi mudar para outro produto",
    "reasonSix": "Outros",
    "addComment": "Adicionar um comentário",
    "cancelSubscription": "Cancelar assinatura",
    "reactivate": "Reative sua assinatura",
    "success": "Sua assinatura foi cancelada e expirará em",
    "error": "Houve um problema ao cancelar sua assinatura. Entre em contato com o suporte.",
    "successReactivate": "Seu projeto foi reativado",
    "errorReactivate": "Houve um problema ao reativar sua assinatura. Entre em contato com o suporte.",
    "contactUs": "Contate o suporte",
    "nonAutomatedCancel": "Entre em contato com o suporte para cancelar sua assinatura",
    "nonAutomatedReactivate": "Entre em contato com o suporte para reativar sua assinatura",
    "cancelsOn": "Cancela em",
    "keepSubscription": "Mantenha a assinatura"
  },
  "limits": {
    "limitedResource": {
      "IndividualMap": "planos",
      "TeamMap": "planos",
      "User": "usuários"
    },
    "out_of": "{{ current }} de {{ maximum }} ativo {{ resources }}",
    "users": {
      "limitReached": {
        "title": "Limite de usuário atingido",
        "content": "Você atingiu o número máximo de usuários para este projeto. Para adicionar mais usuários, por favor"
      },
      "limitRemaining": {
        "title": "1 usuário restante",
        "content": "Você está prestes a atingir o número máximo de usuários para este projeto. Para adicionar mais usuários"
      }
    },
    "custom_layer": {
      "title": "Atualize para personalizar sua camada",
      "content": "Atualize para nosso plano profissional para personalização ilimitada ou entre em contato conosco em:"
    }
  }
}